import React, { useEffect } from 'react';
import { Box, Container, VStack, Text, Button, HStack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { ROUTES, USER_TYPES } from '../constants';


import { User } from '../contexts/UserContext';

interface LandingPageProps {
  user?: User | null;
}

const LandingPage: React.FC<LandingPageProps> = ({ user }) => {
  const navigate = useNavigate();

  // Redirect logged-in users to their home page
  useEffect(() => {
    if (user) {
      if (user.userType === USER_TYPES.INFLUENCER) {
        navigate(ROUTES.INFLUENCER_HOME, { replace: true });
      } else if (user.userType === USER_TYPES.BUSINESS) {
        navigate(ROUTES.BUSINESS_HOME, { replace: true });
      } else if (user.userType === USER_TYPES.ADMIN) {
        navigate(ROUTES.ADMIN_USERS, { replace: true });
      }
    }
  }, [user, navigate]);

  const handleLoginClick = () => {
    navigate(ROUTES.LOGIN);
  };

  const handleBusinessClick = () => {
    navigate(`${ROUTES.LOGIN}?mode=signup&userType=${USER_TYPES.BUSINESS}`);
  };

  const handleInfluencerClick = () => {
    navigate(`${ROUTES.LOGIN}?mode=signup&userType=${USER_TYPES.INFLUENCER}`);
  };
  return (
    <Box className='base-container' >
      {/* Background Image */}
      <Box
        position="absolute"
        top="0"
        left="0"
        width="100%"
        height="100%"
        backgroundImage="url('/assets/images/background-image.png')"
        backgroundSize="cover"
        backgroundPosition="center"
        backgroundRepeat="no-repeat"
        zIndex={1}
      />

      {/* Main Content */}
      <Container
        position="relative"
        zIndex={2}
        height="100%"
        display="flex"
        flexDirection="column"
        padding="0 20px"
      >
        {/* Text Content */}
        <VStack gap={8} marginTop="124px">
          <VStack gap={4} textAlign="center">
            <Text className="title-text" >
              Where Connection Thrives
            </Text>
            <Text className="subtitle-text-center">
              Our trusted partners are content producers and businesses in the Hospitality, Beauty, Fashion, and Wellness sectors.
            </Text>
          </VStack>
        </VStack>

        {/* Action Buttons - Fixed at bottom */}
        <VStack gap={4} marginBottom="32px" marginTop="auto">
          <Button
            className="button-big"
            onClick={handleBusinessClick}
            sx={{
              backgroundColor: "#120F1B !important",
              color: "#FFFFFF !important",
            }}
            _hover={{
              backgroundColor: "#1a1625 !important",
              transform: "translateY(-1px)",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)"
            }}
          >
            For Business
          </Button>
          <Button
            className="button-big"
            onClick={handleInfluencerClick}            
          >
            For Influencers
          </Button>
        </VStack>

        {/* Login Link */}
        <HStack justify="space-between" marginBottom="30px">
          <Text className="static-text">
            Already have an account?
          </Text>
          <Text
            className="regular-text"
            textDecoration="underline"
            onClick={handleLoginClick}
          >
            Login
          </Text>
        </HStack>
      </Container>
    </Box>
  );
};

export default LandingPage;
